import template from './employees_with_roles_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeesWithRolesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class EmployeesWithRolesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeesWithRolesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeesWithRolesHelp',
	dialog_class: EmployeesWithRolesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employees_with_roles_help',
	provider: 'ps'
};
